import { ScrollTrigger } from "@client/gsap";
import React from "react";

import {
    MediaChooserBlock as MediaChooserBlockInterface,
    HeroImageBlock as Value,
} from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { MediaChooserBlock } from "@thelabnyc/thelabui/src/components/MediaChooserBlock";

import { VideoWithPlayPauseButton } from "../VideoWithPlayPauseButton";

import styles from "./index.module.scss";

interface Props {
    value: Value;
}

export const FullWidthMedia = (props: Props) => {
    /**
     * Assuming a StreamBlock inside of a StreamField with a max_num of 1
     */
    const mediaBlock = props.value[0].value;

    const renderMedia = (mediaBlock: MediaChooserBlockInterface) => {
        if (mediaBlock[0].type === "video") {
            return (
                <VideoWithPlayPauseButton
                    value={mediaBlock[0].value}
                    attrs={{
                        onLoad: () => {
                            ScrollTrigger.refresh();
                        },
                    }}
                />
            );
        }

        if (mediaBlock[0].type === "image") {
            return (
                <ImageChooserBlock
                    {...mediaBlock[0]}
                    imageAttrs={{
                        style: {
                            aspectRatio:
                                mediaBlock[0].value.width /
                                mediaBlock[0].value.height,
                        },
                        onLoad: () => {
                            ScrollTrigger.refresh();
                        },
                    }}
                />
            );
        }

        return <MediaChooserBlock value={mediaBlock} />;
    };

    return <section className={styles.root}>{renderMedia(mediaBlock)}</section>;
};
